export const fullLocale: Record<string, string> = {
  en: "en-US",
  es: "es-ES",
  pt: "pt-PT",
  it: "it-IT",
  ja: "ja-JP",
  bg: "bg-BG",
  ru: "ru-RU",
};
